import { Epic, ofType } from "redux-observable";
import { Observable } from "rxjs";
import { exhaustMap } from "rxjs/operators";
import { PersonRepository } from "../../../repositories/persons.repository";
import { QuotationRepository } from "../../../repositories/quotation.repository";
import { RootState } from "../../reducers";
import { QuotationPopupActions } from "../actions";
import { QuotationPopupSubmitForm } from "../actions/default";
import {
    QUOTATION_POPUP_SUBMIT_FORM,
    QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_ACTION,
} from "../constants";

export const quotationPopupValidateDocumentNumberEpic: Epic<
    QuotationPopupActions,
    QuotationPopupActions,
    RootState
> = (action$: Observable<QuotationPopupActions>) =>
    action$.pipe(
        ofType(QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_ACTION),
        exhaustMap((action) => PersonRepository.validateDocumentNumber(action))
    );

export const quotationPopupSubmitFormEpic: Epic<
    QuotationPopupActions,
    QuotationPopupActions,
    RootState
> = (action$: Observable<QuotationPopupActions>) =>
    action$.pipe(
        ofType(QUOTATION_POPUP_SUBMIT_FORM),
        exhaustMap((action) =>
            QuotationRepository.savePreQuotation(
                action as QuotationPopupSubmitForm
            )
        )
    );
